import React, { useContext } from 'react';
import { SearchContainer, SearchInput, SearchIcon } from '../styles';
import { DynamicSVG, Images } from '@lua-frontend/numu-ui';
import { NotificationPanelContext } from '../index';

const HeaderSearch = () => {
  const { filterOptions, dispatch, setFilterOptions } = useContext(NotificationPanelContext);
  return (
    <SearchContainer>
      <SearchIcon>
        <DynamicSVG
          svgPath={Images.searchSvg}
          style={{ color: '#0095FF', width: 20, height: 20 }}
        />
      </SearchIcon>
      <SearchInput
        type="text"
        placeholder="Buscar..."
        value={filterOptions.searchValue}
        onChange={(e) => dispatch(setFilterOptions({ searchValue: e.target.value }))}
      />
    </SearchContainer>
  );
};

export default HeaderSearch;
